import { render, staticRenderFns } from "./PlusPathogen.vue?vue&type=template&id=229396d7&scoped=true"
import script from "./PlusPathogen.vue?vue&type=script&lang=js"
export * from "./PlusPathogen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229396d7",
  null
  
)

export default component.exports